module.exports = __webpack_public_path__ + "media/realtime_vul_r1_animation_2.46690c01.mp4";